import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";

import { http } from "../../helpers/http";
import uuid from "uuid";
import { toast } from "react-toastify";
import { patterns, useForm } from "../../helpers/useForm";
import Auth from "../../auth/Auth";
import {
  loginPost,
  updateOnboardingState,
  updateFullScreenLoader,
} from "../../redux/actions/authActions";
import { Link, useLocation } from "react-router-dom";
import couCode from "../../../src/counteryCode.json";
import ProfileWishlistCart from "./ProfileWishlistCart";
import { clearCart } from "../../helpers/help";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css'

const Onboarding = () => {
  const [modal, setModal] = useState(false);
  const { pathname } = useLocation()
  // const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const [counteryCode, setCounteryCode] = useState(couCode);
  const state = useSelector((state) => state.auth);
  const onboardingState = useSelector((state) => state.auth.onboardingState);
  const loggedUser = Auth.userInfo();
  const [isExisting, setIsExisting] = useState(false);
  const [termsConditions, setTermsConditions] = useState(false);
  const isNewUser = useRef("");
  const [showPassword, setshowPassword] = useState({
    password: false,
  });

  const [loginData, setLoginData] = useState({})

  const [showForgetPassword, setShowForgetPassword] = useState({
    newPass: false,
    confirmPass: false,
  });
  const [otpValue, setOtpValue] = useState();
  const [count, setCount] = useState(0);

  const { values, errors, bindField, isValid, setInitialValues } = useForm({
    validations: {
      ...((onboardingState === "login" ||
        onboardingState === "fpModal" ||
        onboardingState === "signUp") && {
        mobileNumber: {
          required: true,
          maxLength: {
            value: 10,
            message: "Mobile number must be 10 digits",
          },
          minLength: {
            value: 10,
            message: "Mobile number must be 10 digits",
          },
          pattern: {
            value: patterns.onlyNumber,
            message: "Please enter vaild phone number",
          },
        },
      }),

      ...((onboardingState === "signUp" || isExisting) &&
        onboardingState !== "fpModal" && {
        password: {
          required: true,
          minLength: {
            value: 6,
            message: "Password must be at least 6 characters.",
          },
        },
      }),
      ...(onboardingState === "signUp" && {
        otpNumber: {
          required: true,
        },
        countryCode: {
          required: true,
        },
        udId: {
          required: true,
        },
        userName: {
          required: true,
        },
        email: {
          pattern: {
            value: patterns.email,
            message: "Invalid email address.",
          },
          required: true,
        },
        checkbox: {
          required: true,
        },
      }),
    },
  });


  const userUpdateProfile = () => {

    const userData = JSON.parse(sessionStorage.getItem("__takk_out"));
    console.log('userData', userData);
    if (userData) {
      dispatch(updateFullScreenLoader(true));
      const formData = new FormData();
      formData.append('image', null);
      formData.append('userName', userData?.userName);
      formData.append('located_at', sessionStorage.getItem("_current_location"));
      formData.append('email', userData?.email);
      formData.append('countryCode', userData?.countryCode);
      formData.append('mobileNumber', userData?.mobileNumber);
      formData.append(' short_interest_survey', userData?.short_interest_survey && userData?.short_interest_survey === "null" ? "" : userData?.short_interest_survey);
      http(

        {
          method: "POST",
          url: "updateProfile",
          isSecure: true,
          contentType: "multipart/form-data",
          body: formData

        },
        (res) => {
          if (res.error === "false") {
            let value = { 'located_at': sessionStorage.getItem("_current_location") }
            let prevData = JSON.parse(sessionStorage.getItem("__takk_out"));
            Object.keys(value).forEach(function (val, key) {
              prevData[val] = value[val]
            })
            sessionStorage.setItem('__takk_out', JSON.stringify(prevData));
          }
          dispatch(updateFullScreenLoader(false));
        }
      )
    }
  }


  const handleNoButtonClick = () => {
    setModal(false); // Close the modal
    Auth.login({
      ...loginData.Userdetails,
      token: loginData.accessToken,
      type: 'no'
    });
    clearCart();
    userUpdateProfile();
  };

  const handleYesButtonClick = () => {
    setModal(false); // Close the modal
    Auth.login({
      ...loginData.Userdetails,
      token: loginData.accessToken,
      type: 'yes'
    });
    sessionStorage.setItem('_current_location', loginData?.Userdetails?.located_at)
    clearCart();

  };

  const formSubmitHandler = (event, formSubmitType) => {
    event.preventDefault();
    dispatch(updateFullScreenLoader(true));
    let apiUrl = "";
    let bodyData = values;
    const currentLocation = sessionStorage.getItem("_current_location")

    switch (formSubmitType) {
      case "number_Check":
        apiUrl = "CheckAvailability";
        if (isExisting) {
          apiUrl = "userPasswordLogin";
          bodyData.udId = uuid.v4().toUpperCase();
        }
        break;
      case "login":
        apiUrl = "userPasswordLogin";
        bodyData.udId = uuid.v4().toUpperCase();
        break;

      case "signUp":
        apiUrl = "userWithPasswordSignup";
        bodyData.udId = uuid.v4().toUpperCase();
        break;

      case "enterOtp":
        apiUrl = "otpVerification";
        bodyData.otpNumber = otpValue;
        bodyData.udId = uuid.v4().toUpperCase();
        break;
      case "resetPassword":
        apiUrl = "changePassword";
        if (bodyData?.udId) {
          delete bodyData.udId;
        }
        break;

      case "fpModal":
        apiUrl = "forgotPassword";
        break;

      case "reSendOTP":
        setOtpValue("");
        apiUrl = "resendOtp";

      default:
        break;
    }
    // setShowLoader(true)

    http(
      {
        method: "POST",
        url: apiUrl,
        isSecure: true,
        body: bodyData,
      },
      (response) => {
        if (response.error === "false") {
          apiUrl === "CheckAvailability" &&
            (isNewUser.current = response.isNewUser);
          if (
            response?.isNewUser === "true" &&
            formSubmitType === "number_Check"
          ) {
            toast.success(response.errorMessage);
            dispatch(updateOnboardingState("OTPModal"));
            setOtpValue("");
            // setShowLoader(false)
            // dispatch(updateFullScreenLoader(false))
          } else {
            setIsExisting(true);
          }

          if (formSubmitType === "login") {
            if (currentLocation) {
              if (currentLocation !== response?.Userdetails?.located_at) {
                setModal(true);
                setLoginData(response);
              } else {
                setModal(false);
                Auth.login({
                  ...response.Userdetails,
                  token: response.accessToken,
                  type: ''
                });
                sessionStorage.setItem('_current_location', response?.Userdetails?.located_at)
              }
            }


            dispatch(loginPost(true));
            dispatch(updateOnboardingState(""));


          }

          if (formSubmitType === "enterOtp") {
            toast.success(response.errorMessage);
            setInitialValues(values);
            dispatch(updateOnboardingState("signUp"));
          }
          if (formSubmitType === "reSendOTP") {
            toast.success(response.errorMessage);
            dispatch(updateFullScreenLoader(false));
            setInitialValues(values);
            setOtpValue("");
          }

          if (formSubmitType === "signUp") {
            toast.success(response.errorMessage);
            Auth.login({ ...response.userDetails, token: response.token, type: '' });
            dispatch(updateOnboardingState(""));
            dispatch(updateFullScreenLoader(false));
          }

          if (onboardingState === "fpModal") {
            toast.success(response.errorMessage);
            dispatch(updateOnboardingState("OTPModal2"));
            dispatch(updateFullScreenLoader(false));
            setOtpValue("");
          }

          if (
            formSubmitType !== "reSendOTP" &&
            onboardingState === "OTPModal2"
          ) {
            dispatch(updateOnboardingState("resetPassword"));
            dispatch(updateFullScreenLoader(false));
          }

          if (onboardingState === "resetPassword") {
            toast.success(response.errorMessage);
            dispatch(updateOnboardingState(""));
            dispatch(updateFullScreenLoader(false));
          }
        } else {
          toast.error(response.errorMessage);
        }
        dispatch(updateFullScreenLoader(false));
      },
      (errors) => {
        toast.error("something went wrong!");
      }
    );
  };
  const checkUser = () => {
    if (isNewUser.current === "true") {
      dispatch(updateOnboardingState("login"));
    } else {
      dispatch(updateOnboardingState("fpModal"));
    }
  };

  useEffect(() => {
    if (onboardingState === "login") {
      setInitialValues({
        countryCode: "+1",
      });
    }
  }, [onboardingState]);

  useEffect(() => {
    setIsExisting(false);
  }, [values.mobileNumber, values.countryCode]);

  useEffect(() => {
    if (loggedUser) {
      dispatch(loginPost(true));
    }
  }, [loggedUser?.id]);

  useEffect(() => {
    if (values.short_interest_survey) {
      setCount(values.short_interest_survey.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.short_interest_survey]);

  // {
  //   <option value={`+1`}>
  //     {param.id ? frm.country_code : "+1"}
  //   </option>
  // }
  // {country.map((phone, index) => (
  //   <option value={`+${phone}`} key={index}>
  //     +{phone}
  //   </option>
  // ))}

  // {errors.password_confirmation?.type === "manual" && (
  //   <p role="alert" className="text-danger">
  //     Password and confirm password must be matched.
  //   </p>
  // )}

  return (
    <>
      {!pathname.includes("restro-menu") && !state.isUserloggedIn ? (
        <>
          <button
            type="button"
            className="cusbtn me-3"
            onClick={() => {
              setIsExisting(false);
              dispatch(updateOnboardingState("login"));
            }}
          >
            Log In
          </button>
          <button
            type="button"
            className="hoverbtn"
            onClick={() => {
              setIsExisting(false);
              dispatch(updateOnboardingState("login"));
            }}
          >
            Sign Up
          </button>
        </>
      ) : (
        <ProfileWishlistCart />
      )}

      {/* Login Modal */}
      <Modal
        show={onboardingState === "login"}
        onHide={() => dispatch(updateOnboardingState(""))}
        centered
        backdrop="static"
        keyboard={false}
        className="center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>

        <div className="modal_cus">
          <div className="modal-body">
            <h4 className="head4 text-center">Log In</h4>
            <p className="txt text-center">
              Enter your phone number to Proceed
            </p>
            <div className="mt-4">
              <Form
                autoComplete="off"
                onSubmit={(ev) =>
                  formSubmitHandler(ev, !isExisting ? "number_Check" : "login")
                }
              >
                <div className="input-grbox">
                  <label htmlFor="">Phone Number</label>
                  <div className="num-g-input">
                    <span className="selectbox-in">
                      {/* <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="RU"

                      // value={value}
                      // onChange={setValue} 

                      /> */}
                      <select
                        className="border-0 bg-transparent  shadow-none"
                        name="countryCode"
                        {...bindField("countryCode")}
                        value={values?.countryCode}
                      >
                        {/* <option value="+1">+1</option>
                        <option value="+91">+91</option> */}
                        {counteryCode &&
                          counteryCode?.countries
                            ?.sort((a, b) => a.code.localeCompare(b.code))
                            .map((phone, index) => (
                              <option value={phone.code} key={index}>
                                {phone.code}
                              </option>
                            ))}
                      </select>
                    </span>
                    <input
                      type="number"
                      className="input_control ps-2"
                      name="mobileNumber"
                      placeholder="Enter Phone Number"

                      {...bindField("mobileNumber")}
                    />
                  </div>
                  {errors?.mobileNumber && (
                    <span className="text-danger err small">
                      {errors?.mobileNumber}
                    </span>
                  )}

                  {isExisting && (
                    <>
                      <div className="input-grbox mt-4">
                        <label htmlFor="">Password</label>
                        <input
                          type="password"
                          className="input_control ps-2"
                          name="password"
                          placeholder="Enter Password"
                          {...bindField("password")}
                        />

                      </div>
                      {errors?.password && (
                        <span className="text-danger err small">
                          {errors?.password}
                        </span>
                      )}
                      <div className="link_next mt-2 text-end">
                        <button
                          type="button"
                          onClick={() =>
                            dispatch(updateOnboardingState("fpModal"))
                          }
                          className="link_txt"
                        >
                          Forgot Password?
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <div className="btnCont-mt">
                  <button
                    type="submit"
                    disabled={!isValid()}
                    className="cusbtn w-100 text-center"
                  >
                    Log In
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal>

      {/* Sign Up modal */}
      <Modal
        show={onboardingState === "signUp"}
        onHide={() => dispatch(updateOnboardingState(""))}
        centered
        backdrop="static"
        keyboard={false}
        className="center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="modal_cus">
          <div className="modal-body">
            <h4 className="head4 text-center mb-5">Sign Up</h4>
            {/* <p className="txt text-center">Enter your phone number to procced</p> */}
            <div className="mt-4">
              <Form
                onSubmit={(ev) => formSubmitHandler(ev, "signUp")}
                autoComplete="off"
              >
                <div className="input-grbox">
                  <label htmlFor="">Phone Number</label>
                  <div className="num-g-input">
                    <span className="selectbox-in">
                      <select
                        {...bindField("countryCode")}
                        className="border-0 bg-transparent shadow-none "
                        value={values?.countryCode}
                      >
                        <option value="+1">+1</option>
                        <option value="+91">+91</option>
                      </select>
                    </span>
                    <input
                      type="number"
                      readOnly
                      name="mobileNumber"
                      {...bindField("mobileNumber")}
                      className="input_control ps-2"
                    />
                  </div>
                </div>
                {errors?.mobileNumber && (
                  <span className="text-danger err small">
                    {errors?.mobileNumber}
                  </span>
                )}

                <div className="input-grbox mt-4">
                  <label htmlFor="">Email ID</label>
                  <input
                    type="email"
                    className="input_control"
                    placeholder="Enter Email"
                    value={values.email}
                    {...bindField("email")}
                    name="email"
                  />
                </div>
                {errors?.email && (
                  <span className="text-danger err small">{errors?.email}</span>
                )}
                <div className="input-grbox mt-4">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    className="input_control"
                    autoComplete="off"
                    placeholder="Enter Name"
                    name="userName"
                    {...bindField("userName")}
                  />
                </div>
                {errors.userName && (
                  <span className="text-danger err small">
                    {errors.userName}
                  </span>
                )}

                <div className="input-grbox mt-4">
                  <label htmlFor="">Password</label>
                  <div className="passwor-icon-g">
                    <input
                      type={showPassword.password ? "text" : "password"}
                      autoComplete="off"
                      name="password"
                      placeholder="Enter Password"
                      {...bindField("password")}
                      className="input_control"
                    />

                    {
                      <span className="icon-password">
                        <img
                          src={
                            showPassword.password
                              ? "./assets/img/eyesPassword.svg"
                              : "./assets/img/hide_password.svg"
                          }
                          alt="eyes"
                          onClick={() =>
                            setshowPassword((preValues) => ({
                              ...preValues,
                              password: !showPassword.password,
                            }))
                          }
                        />
                      </span>
                    }
                  </div>
                </div>
                {errors.password && (
                  <span className="text-danger err small">
                    {errors.password}arrowBack
                  </span>
                )}
                <div className="checkbox-group d-flex mt-4">
                  <label className="check-container">
                    <input
                      type="checkbox"
                      onChange={() => setTermsConditions(!termsConditions)}
                      className="d-none"
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label>
                    {" "}
                    By creating an account, I accept the{" "}
                    <span className="label-span">
                      {" "}
                      <Link to="https://www.google.com/" target="_blank">
                        Terms and conditions
                      </Link>{" "}
                    </span>
                  </label>
                </div>
                <div className="btnCont-mt">
                  <button
                    type="submit"
                    disabled={!termsConditions && !isValid()}
                    className="cusbtn w-100 text-center"
                  >
                    Continue
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal>

      {/* OTP verfication Modal */}
      <Modal
        show={onboardingState === "OTPModal" || onboardingState === "OTPModal2"}
        onHide={() => dispatch(updateOnboardingState(""))}
        centered
        backdrop="static"
        keyboard={false}
        className="center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="modal_cus">
          <div className="modal-body">
            <a className="arrow_back d-inline" onClick={() => checkUser()}>
              <img src="./assets/img/arrowBack.svg" alt="arrow back" />
            </a>
            <h4 className="head4 text-center"> Enter OTP</h4>
            <p className="txt text-center">Enter your code</p>
            <Form
              onSubmit={(ev) => formSubmitHandler(ev, "enterOtp")}
              autoComplete="off"
            >
              <div className="mt-4 otp_box">
                <OtpInput
                  value={otpValue}
                  onChange={setOtpValue}
                  numInputs={6}
                  placeholder="------"
                  renderSeparator={<span>&nbsp;</span>}
                  renderInput={(props) => (
                    <input {...props} className="otp_control" />
                  )}
                />
                <div className="btnCont-mt">
                  <button
                    disabled={otpValue?.length !== 6}
                    type="submit"
                    className="cusbtn me-3 w-100 "
                  >
                    Verify & proceed
                  </button>
                  <div className="link_next mt-2 text-center">
                    <button
                      type="button"
                      onClick={(ev) => formSubmitHandler(ev, "reSendOTP")}
                      className="link_txt"
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      {/* Forgot passward Modal */}
      <Modal
        show={onboardingState === "fpModal"}
        onHide={() => dispatch(updateOnboardingState(""))}
        centered
        backdrop="static"
        keyboard={false}
        className="center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="modal_cus">
          <div className="modal-body">
            <a
              className="arrow_back d-inline"
              onClick={() => dispatch(updateOnboardingState("login"))}
            >
              <img src="./assets/img/arrowBack.svg" alt="arrow back" />
            </a>
            <h4 className="head4 text-center">Forgot Password</h4>
            <p className="txt text-center">
              Enter your phone number to proceed
            </p>
            <div className="mt-4">
              <Form
                onSubmit={(ev) => formSubmitHandler(ev, "fpModal")}
                autoComplete="off"
              >
                <div className="input-grbox">
                  <label htmlFor="">Phone Number</label>
                  <div className="num-g-input">
                    <span className="selectbox-in">
                      <select
                        className="border-0 bg-transparent"
                        name="countryCode"
                        value={values.countryCode}
                        {...bindField("countryCode")}
                      >
                        {/* <option value="+1">+1</option>
                        <option value="+91">+91</option> */}
                        {
                          counteryCode?.countries
                            ?.sort((a, b) => a.code.localeCompare(b.code))
                            .map((phone, index) => (
                              <option value={phone.code} key={index}>
                                {phone.code}
                              </option>
                            ))}
                      </select>
                    </span>
                    <input
                      type="number"
                      maxLength="10"
                      className="input_control ps-2"
                      name="mobileNumber"
                      value={values.mobileNumber}
                      {...bindField("mobileNumber")}
                    />
                  </div>

                  {errors.mobileNumber && (
                    <span className="text-danger err small">
                      {errors.mobileNumber}
                    </span>
                  )}
                </div>
                <div className="btnCont-mt">
                  <button
                    disabled={!isValid()}
                    type="submit"
                    className="cusbtn w-100 text-center"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal>

      {/* Reset Password */}
      <Modal
        show={onboardingState === "resetPassword"}
        onHide={() => dispatch(updateOnboardingState(""))}
        centered
        backdrop="static"
        keyboard={false}
        className="center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="modal_cus">
          <div className="modal-body">
            <a
              className="arrow_back d-inline"
              onClick={() => dispatch(updateOnboardingState("enterOtp"))}
            >
              <img src="./assets/img/arrowBack.svg" alt="arrow back" />
            </a>
            <h4 className="head4 text-center">Reset Password</h4>
            <p className="txt text-center">Enter your new password</p>
            <div className="mt-4">
              <Form
                onSubmit={(ev) => formSubmitHandler(ev, "resetPassword")}
                autoComplete="off"
              >
                <div className="input-grbox mt-4">
                  <label htmlFor="">New Password</label>
                  <div className="passwor-icon-g">
                    <input
                      type={showForgetPassword.newPass ? "text" : "password"}
                      autoComplete="off"
                      name="password"
                      placeholder="Enter New Password"
                      {...bindField("password")}
                      className="input_control"
                    />

                    {
                      <span className="icon-password">
                        <img
                          src={
                            showForgetPassword.newPass
                              ? "./assets/img/eyesPassword.svg"
                              : "./assets/img/hide_password.svg"
                          }
                          alt="eyes"
                          onClick={() =>
                            setShowForgetPassword((preValues) => ({
                              ...preValues,
                              newPass: !showForgetPassword.newPass,
                            }))
                          }
                        />
                      </span>
                    }
                  </div>
                </div>
                {errors.password && (
                  <span className="text-danger err small">
                    {errors.password}
                  </span>
                )}

                <div className="input-grbox mt-4">
                  <label htmlFor="">Confrim Password</label>
                  <div className="passwor-icon-g">
                    <input
                      type={
                        showForgetPassword.confirmPass ? "text" : "password"
                      }
                      autoComplete="off"
                      name="confirm_password"
                      placeholder="Enter Confrim Password"
                      {...bindField("confirm_password")}
                      className="input_control"
                    />

                    {
                      <span className="icon-password">
                        <img
                          src={
                            showForgetPassword.confirmPass
                              ? "./assets/img/eyesPassword.svg"
                              : "./assets/img/hide_password.svg"
                          }
                          alt="eyes"
                          onClick={() =>
                            setShowForgetPassword((preValues) => ({
                              ...preValues,
                              confirmPass: !showForgetPassword.confirmPass,
                            }))
                          }
                        />
                      </span>
                    }
                  </div>

                  {values.password !== values.confirm_password &&
                    values.confirm_password ? (
                    <span className="text-danger err small">
                      {" "}
                      Password doesn't match
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="btnCont-mt">
                  <button
                    type="submit"
                    disabled={
                      !isValid() || values.password !== values.confirm_password
                    }
                    className="cusbtn w-100 text-center"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal>




      <Modal
        show={modal}
        backdrop="static"
        onHide={() => setModal(false)}
        centered
        className="logoutmodal center-close-icon"
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <div className="bodyModal">
          <p className="txt text-center mb-2">Your last selected location is <h4 className="font-bold text-center">{sessionStorage.getItem("_current_location") == 'st_thomas' ? 'St. Croix' : 'St. Thomas'}</h4> Do you want to switch? If yes your cart will be cleared.</p>
          {/* <h4 className="font-bold text-center">{sessionStorage.getItem("_current_location") == 'st_thomas' ? 'St. Croix' : 'St. Thomas'}</h4> */}
          <div className="footerM text-center mt-4">
            <button
              className="cusbtn me-3 minonehunt"
              onClick={handleYesButtonClick}
            >
              Yes, Switch Location
            </button>
            <button
              className="hoverbtn minonehunt"
              onClick={handleNoButtonClick}
            >
              Don't Switch
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Onboarding;
